const freeFeatures = [
  "Digital cut sheets",
  "Standard fittings",
  "Round and square shapes",
  "Automated error checking",
  "Export to PDF",
];

const visualFeatures = [
  ...freeFeatures,
  "Expanded fitting libraries",
  "Oval shapes",
  "Visual error checking",
  "Export to PDF",
  "Export CSV",
];

const ProFeatures = [
  ...visualFeatures,
  "Unlimited sites and runs",
  "Customized fittings",
  "Custom shapes",
  "AI error checking",
  "Export to PDX",
];

export const plans = {
  free: {
    plan: "Free",
    description: "Free Forever",
    price: 0,
    features: freeFeatures,
    buttonLabel: "Register",
    recommended: false,
  },
  visual: {
    plan: "Pro",
    description: "Billed Annualy",
    price: 29.99,
    features: visualFeatures,
    buttonLabel: "Upgrade",
    recommended: false,
  },
  pro: {
    plan: "Enterprise",
    description: "Billed Annualy",
    price: 59.99,
    features: ProFeatures,
    buttonLabel: "Upgrade",
    recommended: true,
  },
};
